import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { updateUserInfo } from 'containers/App/actions';
import CalendarTimeZoneSelect from 'components/Calendar/Calendar.TimeZoneSelect';
import APModal from 'components/Modal/APModal';
import { useAction } from 'hooks/useAction';

import './timezone-set-modal.scss';

const TimezoneSetModal = () => {
  const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [open, setIsOpen] = useState(true);
  const [timeZone, setTimeZone] = useState(currentTimeZone);

  const userTimezone = useSelector((state) => state.global.userInfo.timezone);

  const updateTimezone = useAction((timezone) => updateUserInfo({ timezone }));

  const handleTimezoneUpdate = () => {
    updateTimezone(timeZone);
    setIsOpen(false);
  };

  const handleDecline = () => {
    setIsOpen(false);
  };

  if (userTimezone) {
    return null;
  }

  return (
    <APModal
      open={open}
      name="set-time-zone"
      title="Set your time zone."
      onClose={() => setIsOpen(false)}
      actions={(
        <>
          <button
            className="button button--outline button--delete"
            onClick={handleDecline}
          >
            Cancel
          </button>
          <button
            className="button button--outline button--save"
            onClick={handleTimezoneUpdate}
          >
            Save
          </button>
        </>
      )}
    >
      <div className="change-timezone">
        <p>
          Let’s make sure everything shows up in your local time. Pick your time zone from the list below.
          <CalendarTimeZoneSelect
            myTimeZone={currentTimeZone}
            timeZone={timeZone}
            onTimeZoneChange={(e) => setTimeZone(e.target.value)}
            displayMyTimezone
          />
        </p>
      </div>
    </APModal>
  );
};

export default TimezoneSetModal;
